import { SamplesProPlan } from 'constants/brands';
import { Interval, SampleCatalog } from 'types/generated/subscriptionsApi';
import { t } from '@lingui/macro';
import getPlanPrices from 'helpers/getPlanPrices/getPlanPrices';
import { GetDiscountedPlan } from 'hooks/useGetDiscountedPlan/useGetDiscountedPlan';

const useSamplePlan = ({
    frequency,
    hasSamplesPlan,
    samplesCatalog,
    getDiscountedPlan,
}: {
    frequency: Interval;
    hasSamplesPlan: boolean;
    samplesCatalog: SampleCatalog | undefined;
    getDiscountedPlan: GetDiscountedPlan;
}) => {
    const title = SamplesProPlan;
    const info = hasSamplesPlan
        ? t`This will update your existing plan and billing date. You'll instantly get your new credits.`
        : undefined;

    const planByFrequency = samplesCatalog?.plans?.find(
        (plan) => plan?.frequency === frequency,
    );

    const discountedPlan = getDiscountedPlan({
        planCode: planByFrequency?.code,
        frequency,
    });

    const subscriptionPrice = planByFrequency?.subscriptionPrice ?? 0;
    const monthlyEquivalentPrice = subscriptionPrice / 12;

    const { salePrice, monthlyEquivalentSalePrice } = getPlanPrices({
        subscriptionPrice,
        monthlyEquivalentPrice,
        discountPercentage: discountedPlan?.discountPercentage,
    });

    return {
        code: planByFrequency?.code,
        currency: samplesCatalog?.currency,
        info,
        monthlyEquivalentPrice:
            frequency === 'Yearly' ? monthlyEquivalentPrice : subscriptionPrice,
        monthlyEquivalentSale:
            frequency === 'Yearly' ? monthlyEquivalentSalePrice : salePrice,
        salePrice: salePrice,
        subscriptionPrice: subscriptionPrice,
        title,
    };
};

export default useSamplePlan;
